// Single canonical list of "material of construction" / surface values, shared by
// every screen that offers one, so a new equipment part and a sampling location not
// tied to a specific part suggest the same standard spellings (SS316 vs SS 316 vs
// SS-316 drift was the actual "surface isn't a real lookup" gap — not a missing FK,
// since equipment_parts.material_of_construction is already read everywhere else
// derives its surface options from — see analyticalMethods.js, acceptanceCriteria.js,
// cleaningConfig.js).
export const STANDARD_MATERIALS_OF_CONSTRUCTION = [
  'SS316',
  'SS316L',
  'SS304',
  'Glass',
  'PVC',
  'PTFE',
  'Epoxy Coated Floor',
  'Painted Wall',
  'Rubber Gasket',
  'Silicone',
];
